import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["messageTemplateSelect"]

  getSubjectTemplate(event) {
    event.preventDefault()

    if (this.hasMessageTemplateSelectTarget) {
      let selectedIndex = this.messageTemplateSelectTarget.selectedIndex;
      let subject = this.messageTemplateSelectTarget.options[selectedIndex].text
      this.setSubjectTemplate(subject)
    }
  }

  setSubjectTemplate(subject) {
    let subjectHiddenField = document.getElementById("invoice_communication_form_subject")
    subjectHiddenField.value = subject
  }
}
